import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { XIcon } from 'lucide-react';
function LegalModal({
  isOpen,
  onClose,
  title,
  children
}: {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  children: React.ReactNode;
}) {
  return <AnimatePresence data-id="element-27">
      {isOpen && <motion.div initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} exit={{
      opacity: 0
    }} transition={{
      duration: 0.2
    }} className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/60" onClick={onClose} data-id="element-28">
          <motion.div initial={{
        opacity: 0,
        scale: 0.95,
        y: 20
      }} animate={{
        opacity: 1,
        scale: 1,
        y: 0
      }} exit={{
        opacity: 0,
        scale: 0.95,
        y: 20
      }} transition={{
        duration: 0.25
      }} className="bg-white rounded-2xl w-full max-w-2xl max-h-[80vh] overflow-hidden shadow-2xl" onClick={e => e.stopPropagation()} data-id="element-29">
            <div className="flex items-center justify-between p-5 md:p-6 border-b border-kitchen-brown/10" data-id="element-30">
              <h2 className="font-lora text-xl md:text-2xl font-bold text-kitchen-brown" data-id="element-31">
                {title}
              </h2>
              <button onClick={onClose} className="p-2 rounded-full hover:bg-kitchen-cream transition-colors" aria-label="Cerrar" data-id="element-32">
                <XIcon className="w-5 h-5 text-kitchen-brown/60" data-id="element-33" />
              </button>
            </div>
            <div className="p-5 md:p-8 overflow-y-auto max-h-[calc(80vh-72px)] font-nunito text-kitchen-brown/80 text-sm md:text-base leading-relaxed space-y-4" data-id="element-34">
              {children}
            </div>
          </motion.div>
        </motion.div>}
    </AnimatePresence>;
}
export function Footer() {
  const [showPrivacy, setShowPrivacy] = useState(false);
  const [showTerms, setShowTerms] = useState(false);
  return <>
      <footer className="bg-[#2A180E] py-8 text-center px-6" data-id="element-35">
        <div className="flex items-center justify-center gap-4 mb-4" data-id="element-36">
          <button onClick={() => setShowPrivacy(true)} className="font-nunito text-white/50 text-sm hover:text-white/80 underline underline-offset-2 transition-colors" data-id="element-37">
            Política de Privacidad
          </button>
          <span className="text-white/30" data-id="element-38">|</span>
          <button onClick={() => setShowTerms(true)} className="font-nunito text-white/50 text-sm hover:text-white/80 underline underline-offset-2 transition-colors" data-id="element-39">
            Términos y Condiciones
          </button>
        </div>
        <p className="font-nunito text-white/50 text-sm" data-id="element-40">
          © {new Date().getFullYear()} El Método Lunchera Vecinal. Todos los
          derechos reservados.
        </p>
        <p className="font-nunito text-white/30 text-xs mt-2 max-w-2xl mx-auto" data-id="element-41">
          Este sitio no es parte del sitio web de Facebook o Facebook Inc.
          Además, este sitio NO está respaldado por Facebook de ninguna manera.
          FACEBOOK es una marca registrada de FACEBOOK, Inc.
        </p>
      </footer>

      {/* Privacy Policy Modal */}
      <LegalModal isOpen={showPrivacy} onClose={() => setShowPrivacy(false)} title="Política de Privacidad" data-id="element-42">
        <p className="font-bold text-kitchen-brown" data-id="element-43">
          Última actualización:{' '}
          {new Date().toLocaleDateString('es-ES', {
          year: 'numeric',
          month: 'long',
          day: 'numeric'
        })}
        </p>
        <p data-id="element-44">
          En El Método Lunchera Vecinal, nos comprometemos a proteger tu
          privacidad. Esta política describe cómo recopilamos, usamos y
          protegemos tu información personal.
        </p>
        <h3 className="font-lora font-bold text-kitchen-brown text-base md:text-lg" data-id="element-45">
          1. Información que Recopilamos
        </h3>
        <p data-id="element-46">
          Recopilamos únicamente la información necesaria para procesar tu
          compra y entregarte el producto digital, incluyendo: nombre, dirección
          de correo electrónico y datos de pago procesados de forma segura por
          nuestro proveedor de pagos.
        </p>
        <h3 className="font-lora font-bold text-kitchen-brown text-base md:text-lg" data-id="element-47">
          2. Uso de la Información
        </h3>
        <p data-id="element-48">
          Tu información se utiliza exclusivamente para: procesar tu pedido,
          enviarte el producto adquirido, y comunicarte actualizaciones
          importantes relacionadas con tu compra. No vendemos, alquilamos ni
          compartimos tu información personal con terceros.
        </p>
        <h3 className="font-lora font-bold text-kitchen-brown text-base md:text-lg" data-id="element-49">
          3. Protección de Datos
        </h3>
        <p data-id="element-50">
          Utilizamos medidas de seguridad estándar de la industria para proteger
          tu información personal. Los pagos son procesados a través de
          plataformas seguras con encriptación SSL.
        </p>
        <h3 className="font-lora font-bold text-kitchen-brown text-base md:text-lg" data-id="element-51">
          4. Cookies
        </h3>
        <p data-id="element-52">
          Este sitio puede utilizar cookies para mejorar tu experiencia de
          navegación y analizar el tráfico del sitio. Puedes configurar tu
          navegador para rechazar cookies si lo prefieres.
        </p>
        <h3 className="font-lora font-bold text-kitchen-brown text-base md:text-lg" data-id="element-53">
          5. Tus Derechos
        </h3>
        <p data-id="element-54">
          Tienes derecho a acceder, corregir o eliminar tu información personal
          en cualquier momento. Para ejercer estos derechos, puedes comunicarte
          con nosotros a través de los canales disponibles en nuestro sitio.
        </p>
      </LegalModal>

      {/* Terms & Conditions Modal */}
      <LegalModal isOpen={showTerms} onClose={() => setShowTerms(false)} title="Términos y Condiciones" data-id="element-55">
        <p className="font-bold text-kitchen-brown" data-id="element-56">
          Última actualización:{' '}
          {new Date().toLocaleDateString('es-ES', {
          year: 'numeric',
          month: 'long',
          day: 'numeric'
        })}
        </p>
        <p data-id="element-57">
          Al acceder y utilizar este sitio web y adquirir El Método Lunchera
          Vecinal, aceptas los siguientes términos y condiciones.
        </p>
        <h3 className="font-lora font-bold text-kitchen-brown text-base md:text-lg" data-id="element-58">
          1. Producto Digital
        </h3>
        <p data-id="element-59">
          El Método Lunchera Vecinal es un producto digital educativo e
          informativo. Los resultados pueden variar según el esfuerzo,
          dedicación y circunstancias individuales de cada persona. No
          garantizamos ingresos específicos.
        </p>
        <h3 className="font-lora font-bold text-kitchen-brown text-base md:text-lg" data-id="element-60">
          2. Uso del Producto
        </h3>
        <p data-id="element-61">
          Al adquirir el producto, recibes una licencia personal e
          intransferible para uso individual. Queda prohibida la reproducción,
          distribución o reventa del contenido sin autorización expresa.
        </p>
        <h3 className="font-lora font-bold text-kitchen-brown text-base md:text-lg" data-id="element-62">
          3. Pagos y Reembolsos
        </h3>
        <p data-id="element-63">
          Todos los pagos son procesados de forma segura. Debido a la naturaleza
          digital del producto, todas las ventas son finales. Si tienes algún
          problema con tu compra, nos comprometemos a ayudarte a resolver
          cualquier inconveniente.
        </p>
        <h3 className="font-lora font-bold text-kitchen-brown text-base md:text-lg" data-id="element-64">
          4. Responsabilidad
        </h3>
        <p data-id="element-65">
          El contenido de este producto es únicamente con fines educativos e
          informativos. El usuario es responsable de cumplir con las leyes y
          regulaciones locales aplicables en su jurisdicción. No nos hacemos
          responsables por decisiones tomadas basándose en el contenido del
          producto.
        </p>
        <h3 className="font-lora font-bold text-kitchen-brown text-base md:text-lg" data-id="element-66">
          5. Modificaciones
        </h3>
        <p data-id="element-67">
          Nos reservamos el derecho de modificar estos términos en cualquier
          momento. Las modificaciones entrarán en vigor inmediatamente después
          de su publicación en este sitio.
        </p>
      </LegalModal>
    </>;
}